import React from "react";
import axios from "../api/axios";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import { downloadBlobFile } from "../api/azure";

export default function PropertyThumbnail({
  thumbnail,
  isthumbnail = false,
  isSpotlight = false,
}) {
  const blobContainerName = "propertyimages";
  const state = useSelector((state) => state.UserReducer);
  const downloadImage = async (thumbnail) => {
    try {
      if (thumbnail.blobName !== undefined && thumbnail.blobName !== "") {
        const azureDownloadresult = await downloadBlobFile(
          thumbnail.blobContainer,
          thumbnail.blobName,
          thumbnail.originalname,
        );
        if (azureDownloadresult.status === "success") {
          const azureData = azureDownloadresult.data;
          setThumbnailImage(azureData);
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      return "";
    }
  };

  const saveImage = async (thumbnail) => {
    try {
      const azureDownloadresult = await downloadBlobFile(
        blobContainerName,
        thumbnail.blobName,
        thumbnail.originalname,
      );
      if (azureDownloadresult.status === "success") {
        const azureData = azureDownloadresult.data;
        const downloadFileUrl = window.URL.createObjectURL(azureData);
        const temporaryDownloadLink = document.createElement("a");
        temporaryDownloadLink.href = downloadFileUrl;
        temporaryDownloadLink.setAttribute("download", thumbnail.originalname);
        temporaryDownloadLink.click();
      } else {
        toast.error("Something went wrong with file download");
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
      return "";
    }
  };

  const [thumbnailImage, setThumbnailImage] = React.useState(null);

  React.useEffect(() => {
    if (thumbnail) downloadImage(thumbnail);
  }, []);

  return (
    <>
      <img
        src={
          thumbnailImage
            ? URL.createObjectURL(thumbnailImage)
            : "/assets/images/thumbnail_loading_placeholder.jpg"
        }
        alt='thumbnail'
        onClick={(e) => {
          if (thumbnailImage && !isthumbnail)
            // window.open(URL.createObjectURL(thumbnailImage));
            saveImage(thumbnail);
        }}
        referrerPolicy='no-referrer'
        className={`${
          isthumbnail ? "" : isSpotlight ? "h-full" : "p-4 h-32"
        } cursor-pointer`}
      />
    </>
  );
}
